/**
 * About image collage: viewport-right pin only (translateX on [data-rb-pin-inner]).
 * Parallax + entrance use Sleek `parallax-element` + `motion-element` (fade-in) in the section Liquid.
 */
(function () {
  'use strict';

  function bindCollagePin(root) {
    if (root.getAttribute('data-rb-pin-mounted') === 'true') return;
    if (!root.querySelector('[data-rb-pin-inner]')) return;
    root.setAttribute('data-rb-pin-mounted', 'true');

    var grid = root.querySelector('.about-image-collage__grid');
    var mql = window.matchMedia('(min-width: 750px)');
    var scrollOn = false;
    var pinTicking = false;
    var pinRaf = null;

    function updateViewportPinShift() {
      var inners = root.querySelectorAll('[data-rb-pin-inner]');
      if (!inners.length) return;

      if (!mql.matches) {
        inners.forEach(function (el) {
          el.style.transform = '';
        });
        return;
      }

      var vw = window.innerWidth;
      var rootStyle = window.getComputedStyle(document.documentElement);
      var railMax = parseFloat(rootStyle.getPropertyValue('--bm-layout-max-width')) || 2400;
      var railWidth = Math.min(vw, railMax);
      var railLeft = Math.round((vw - railWidth) / 2);
      var railRight = railLeft + railWidth;
      var edgeInset = 10;
      var rootRect = root.getBoundingClientRect();
      var targetRight = Math.min(Math.round(rootRect.right) - edgeInset, railRight - edgeInset);

      inners.forEach(function (el) {
        var item = el.closest('.about-image-collage__item');
        if (!item) return;
        el.style.transform = '';
        var r = item.getBoundingClientRect();
        var delta = Math.max(0, Math.round(targetRight - r.right));
        el.style.transform = 'translateX(' + delta + 'px)';
      });
    }

    function onScrollPin() {
      if (pinTicking) return;
      pinTicking = true;
      pinRaf = requestAnimationFrame(function () {
        updateViewportPinShift();
        pinTicking = false;
        pinRaf = null;
      });
    }

    function syncPinScroll() {
      var inners = root.querySelectorAll('[data-rb-pin-inner]');
      var needs = inners.length > 0 && mql.matches;
      if (needs && !scrollOn) {
        scrollOn = true;
        window.addEventListener('scroll', onScrollPin, { passive: true });
        if (typeof document !== 'undefined' && 'onscrollend' in document) {
          document.addEventListener('scrollend', onScrollPin, { passive: true });
        }
      } else if (!needs && scrollOn) {
        scrollOn = false;
        window.removeEventListener('scroll', onScrollPin);
        if (typeof document !== 'undefined' && 'onscrollend' in document) {
          document.removeEventListener('scrollend', onScrollPin);
        }
      }
      updateViewportPinShift();
    }

    var boundResize = updateViewportPinShift;
    var pinResizeObserver = null;
    if (grid && typeof ResizeObserver !== 'undefined') {
      pinResizeObserver = new ResizeObserver(boundResize);
      pinResizeObserver.observe(grid);
    }
    window.addEventListener('resize', boundResize, { passive: true });
    mql.addEventListener('change', syncPinScroll);

    syncPinScroll();
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        updateViewportPinShift();
        /* Nudge layout + Motion scroll timelines after pin rects settle (parallax + pin share this subtree). */
        window.dispatchEvent(new Event('resize'));
      });
    });

    root._rbPinCleanup = function () {
      if (scrollOn) {
        window.removeEventListener('scroll', onScrollPin);
        if (typeof document !== 'undefined' && 'onscrollend' in document) {
          document.removeEventListener('scrollend', onScrollPin);
        }
      }
      if (pinRaf) cancelAnimationFrame(pinRaf);
      window.removeEventListener('resize', boundResize);
      mql.removeEventListener('change', syncPinScroll);
      if (pinResizeObserver && grid) {
        pinResizeObserver.unobserve(grid);
        pinResizeObserver.disconnect();
      }
      root.querySelectorAll('[data-rb-pin-inner]').forEach(function (el) {
        el.style.transform = '';
      });
      root.removeAttribute('data-rb-pin-mounted');
      delete root._rbPinCleanup;
    };
  }

  function init() {
    document.querySelectorAll('.about-image-collage').forEach(bindCollagePin);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
